export const heading = (title) => {
    document.querySelector('.header-title').innerHTML = title;
}